import { Link } from "react-router-dom";
import { Phone, Mail, MessageSquareText } from "lucide-react";
import { BRAND, LOGO } from "@/data/site";

export default function Footer() {
  return (
    <footer className="relative border-t border-cyan-400/15 bg-[#030712]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO} alt="Your Surface My Purpose logo" className="w-10 h-10 rounded-lg border border-cyan-400/30 object-cover" data-testid="footer-logo-image" />
              <span className="font-display font-black italic uppercase text-xl">Your Surface <span className="text-cyan-400">My Purpose</span></span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">{BRAND.tagline}</p>
            <p className="text-slate-500 text-sm mt-3">Pressure Washing & Surface Cleaning — Residential & Commercial</p>
          </div>
          <div>
            <p className="font-mono-brand text-xs tracking-[0.3em] uppercase text-cyan-400 font-bold mb-5">Contact</p>
            <div className="flex flex-col gap-4">
              <a href={`tel:${BRAND.phoneRaw}`} data-testid="footer-call-link" className="flex items-center gap-3 text-slate-300 hover:text-cyan-400 transition-colors">
                <Phone className="w-4 h-4 text-cyan-400" /> {BRAND.phone}
              </a>
              <a href={`sms:${BRAND.phoneRaw}`} data-testid="footer-text-link" className="flex items-center gap-3 text-slate-300 hover:text-cyan-400 transition-colors">
                <MessageSquareText className="w-4 h-4 text-cyan-400" /> Text us anytime
              </a>
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-slate-300 hover:text-cyan-400 transition-colors">
                <Mail className="w-4 h-4 text-cyan-400" /> {BRAND.email}
              </a>
            </div>
          </div>
          <div>
            <p className="font-mono-brand text-xs tracking-[0.3em] uppercase text-cyan-400 font-bold mb-5">Explore</p>
            <div className="flex flex-col gap-3">
              <Link to="/services" data-testid="footer-link-services" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">Our Services</Link>
              <Link to="/gallery" data-testid="footer-link-gallery" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">Work Gallery</Link>
              <Link to="/contact" data-testid="footer-link-estimate" className="text-slate-300 hover:text-cyan-400 transition-colors text-sm">Request a Free Estimate</Link>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-cyan-400/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-slate-500 text-xs font-mono-brand tracking-widest uppercase">© {new Date().getFullYear()} Your Surface My Purpose LLC</p>
          <p className="text-slate-500 text-xs font-mono-brand tracking-widest uppercase">Let us wash your worries away</p>
        </div>
      </div>
    </footer>
  );
}
